/**
 * @module LikeBox
 * @return {Object} public methods.
 */
const LikeBox = (function () {
    var $win;
    var $doc;
    var $likeBox;
    var $footer;

    function init() {
        $likeBox = $(".like-box");

        if ($likeBox.length === 0) return false;

        getDOMElements();
        addEventListener();
        handleSticky();
    }

    function getDOMElements() {
        $win = $(window);
        $doc = $(document);
        $footer = $('.footer');
    }

    function addEventListener() {
        $doc.on('scroll', onDocumentScroll);
    }

    function onDocumentScroll() {
        handleSticky();
    }

    function handleSticky() {
        var st = $win.scrollTop();

        if (st >= lastScrollTop) {
            // downscroll code
            // opacity
            if ($footer.offset()['top'] + 100 < $win.height() || st > 100) {
                $likeBox.show();
            }
            // position
            if ($likeBox.offset()['top'] + $likeBox.outerHeight() + parseFloat($likeBox.css('bottom')) >= $footer.offset()['top']) {
                if ($likeBox.hasClass('fixed')) $likeBox.removeClass('fixed');
            }
        } else {
            // upscroll code
            // opacity
            if ($footer.offset()['top'] + 100 > $win.height() && st < $win.height() + 100) {
                //$likeBox.hide();
            }
            // position
            if ($likeBox.offset()['top'] + $likeBox.outerHeight() + 20 >= $win.scrollTop() + $win.height()) {
                if (!$likeBox.hasClass('fixed')) $likeBox.addClass('fixed');
            }
        }
        lastScrollTop = st;
    }

    // Return public methods
    return {
        init: init
    };
})();

window.LikeBox = LikeBox;
export default LikeBox;
